import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { Organization } from 'models/organization';
import { User } from 'models/user';

type SupplierSummaryProps = {
    supplier?: Partial<Organization>;
    exceptionReasons?: string[];
    responsibleUser?: Partial<User>;
};
const SupplierSummary: FC<SupplierSummaryProps> = ({ supplier, exceptionReasons, responsibleUser }) => {
    const { t: translate } = useTranslation(['common', 'client-directory', 'orders']);

    return (
        <Fragment>
            {supplier ? (
                <Fragment>
                    <Box display="flex">
                        <Box mr={1}>
                            <Typography variant="subtitle2">{translate('client-directory:SUPPLIER')}:</Typography>
                        </Box>
                        <Box>{supplier.name}</Box>
                    </Box>
                    {responsibleUser?.fullName ? (
                        <Box display="flex">
                            <Box mr={1}>
                                <Typography variant="subtitle2">{translate('orders:RESPONSIBLE_USER')}:</Typography>
                            </Box>
                            <Box>{responsibleUser.fullName}</Box>
                        </Box>
                    ) : undefined}
                    <Box>
                        {exceptionReasons?.length ? (
                            <Box display="flex">
                                <Box mr={1}>
                                    <Typography variant="subtitle2">
                                        {translate('orders:REASON_FOR_EXCEPTION')}:
                                    </Typography>
                                </Box>
                                <Box>
                                    {exceptionReasons
                                        .map((exceptionReason) => translate(`orders:${exceptionReason}`))
                                        .join(', ')}
                                </Box>
                            </Box>
                        ) : undefined}
                    </Box>
                </Fragment>
            ) : undefined}
        </Fragment>
    );
};

export default SupplierSummary;
